import { WithStyles, withStyles } from '@mui/styles';

import { SSOLogout } from './ssoLogout';
import { muiStyles } from './styles';

export type SSOLogoutProps = WithStyles<typeof muiStyles>;

export default withStyles(muiStyles)(SSOLogout);